import { render, staticRenderFns } from "./DocumentAdd.vue?vue&type=template&id=63c49e1a&scoped=true&"
import script from "./DocumentAdd.vue?vue&type=script&lang=js&"
export * from "./DocumentAdd.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAdd.vue?vue&type=style&index=0&id=63c49e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c49e1a",
  null
  
)

export default component.exports